export default {
    props: {
        filesFileExtension: {
            type: String,
            default: undefined,
            kComposite: 'files.file.extension'
        }, 
        filesFileName: {
            type: String,
            default: undefined,
            kComposite: 'files.file.name'
        }, 
        filesFileSize: {
            type: Number,
            default: undefined,
            kComposite: 'files.file.size'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-upload-vue-wrapper/src/KendoUpload/Files.js